import { startCase } from 'lodash-es';

import { TASK_CONST } from '@/constant';
import type { FrameData, User } from '@/type';

import { FRAME_STATUS_BADGE_VARIANT_MAP } from './constant';

export const getStatusBadgeVariant = (
  status:
    | Capitalize<TASK_CONST.TASK_FRAME_WORKSTATE>
    | TASK_CONST.TASK_FRAME_WORKSTATE,
) => {
  return (
    FRAME_STATUS_BADGE_VARIANT_MAP[status] ??
    FRAME_STATUS_BADGE_VARIANT_MAP[TASK_CONST.TASK_FRAME_WORKSTATE.PREWORK]
  );
};

export const getStatusText = (
  status:
    | Capitalize<TASK_CONST.TASK_FRAME_WORKSTATE>
    | TASK_CONST.TASK_FRAME_WORKSTATE,
) => {
  return startCase(FRAME_STATUS_BADGE_VARIANT_MAP[status]);
};

export const isApplicableFrame = (
  frame: Pick<FrameData, 'reviewerID' | 'workerID' | 'workState'>,
) => {
  const { workState } = frame;

  return workState === TASK_CONST.TASK_FRAME_WORKSTATE.WORKING;
};

export const isAssignedFrame = (
  frame: Pick<FrameData, 'reviewerID' | 'workerID' | 'workState'>,
  user: User,
) => {
  const { workerID, workState } = frame;

  if (!isApplicableFrame(frame)) {
    return false;
  }

  if (workState === TASK_CONST.TASK_FRAME_WORKSTATE.WORKING) {
    return workerID === user.id;
  }

  return false;
};
